import React from 'react';

class ShowcaseCard extends React.Component {
	constructor(props) {
		super(props);
		this.addActiveClass= this.addActiveClass.bind(this);
		this.state = {
			active: false
		}
	}
	addActiveClass() {
		this.setState({active: !this.state.active})
	}
	render () {
		return (
			<div className={this.state.active ? 'showcase__card active u-p-' : 'showcase__card u-p-'} onClick={() => {this.addActiveClass();}}>
				<div className="row">
					<div className="sm-12 col u-mb-">
						<h3>{this.props.title}</h3>
						<p>{this.props.description}</p>
					</div>
					<div className="sm-12 col">
						<h4 className="bold">Tech Used</h4>
						<ul>
							{this.props.techUsed.map(function(value, index) {
								return <li className="showcase__card__list-item" key={index}>{value}</li>
							})}
						</ul>
					</div>
					<div className="sm-12 col showcase__card__image">
						<img src={this.props.imageSource} alt={this.props.imageAlt}/>	
					</div>
				</div>
			</div>
		)
	}
};

export default ShowcaseCard;


// WEBPACK FOOTER //
// ./src/components/ShowcaseCard.js